import React, { RefObject } from 'react';
import classNames from 'classnames';
import './PaymentMethodBraintreeInput.scss';

type Props = {
  ref?: RefObject<HTMLDivElement | null>;
  error?: boolean | string;
};

export const PaymentMethodBraintreeInput: React.FC<Props> = ({ ref, error }) => (
  <div
    ref={ref}
    className={classNames('PaymentMethodBraintreeInput', {
      ['PaymentMethodBraintreeInput--error']: error
    })}
  />
);
